import { IFilterObject } from '../../components/FilterComponent'
import { IPresetDTO } from './types'

const getRandomInt = () => {
  const min = 1
  const max = 10000
  return Math.floor(Math.random() * (max - min) + min) // The maximum is exclusive and the minimum is inclusive
}

const getSelectedValuesForPreset = (filters: IFilterObject[]) => {
  let selectedValues: { [key: string]: string } = {}

  filters.forEach(filter => {
    if (filter.section) {
      const checkedInSection = filter.subTypes
        ?.filter(subType => subType.checked)
        .map(type => type.value)

      if (checkedInSection?.length) {
        selectedValues = { ...selectedValues, [filter.value]: checkedInSection.join() }
      }
    }
  })

  return selectedValues
}

const formatPresets = (data: IPresetDTO[]) =>
  data.map(preset => {
    const values = Object.keys(preset)
      .filter(key => !['id', 'user', 'uuid', 'name'].includes(key) && preset[key])
      .map(filteredKey => {
        const keyValues = preset[filteredKey] as string
        return keyValues.split(',')
      })
      .flat()
    return {
      id: preset.id as number,
      name: preset?.name as string,
      values,
      checked: false,
    }
  })

const getSelectedValues = (filters: IFilterObject[]) => {
  const selectedValues: { [key: string]: string[] } = {}

  filters.forEach(filter => {
    if (filter.section) {
      const checkedInSection = filter.subTypes
        ?.filter(subType => subType.checked)
        .map(type => type.value)

      if (checkedInSection?.length) {
        selectedValues[filter.value] = checkedInSection
      }
    }
  })

  return selectedValues
}

const getSelectedValuesCount = (filters: IFilterObject[]) => {
  let counter = 0
  filters.forEach(filter => {
    const subTypes = filter?.subTypes || []
    for (let i = 0; i < subTypes.length; i++) {
      if (subTypes[i].checked) counter++
    }
  })
  return counter
}

export default {
  getRandomInt,
  getSelectedValuesForPreset,
  formatPresets,
  getSelectedValues,
  getSelectedValuesCount,
}
